import { ChangeDetectionStrategy, Component, Input, Output, EventEmitter } from '@angular/core';

import { ISubMenuCollection } from './sub.nav.interface';

@Component({
    selector: 'mlp-ng-sub-nav',
    templateUrl: './sub.nav.component.html',
    styleUrls: ['./sub.nav.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})

export class SubNavSharedComponent {
    @Input() links: ISubMenuCollection;
    @Output() toggleDropdown: EventEmitter<boolean> = new EventEmitter<boolean>();

    toggle(): void {
        this.links.showMenu = !this.links.showMenu;
        this.toggleDropdown.emit(this.links.showMenu);
    }
}
